/* eslint-disable no-console */
import { call } from 'redux-saga/effects';
import HttpUtils from './http-util';

function* safeApiCall(effect) {
  try {
    return { error: false, response: yield effect };
  } catch (err) {
    return { error: true, response: err };
  }
}

function* getRequest(url, params, options) {
  const effect = call(HttpUtils.get, url, params, options);
  return yield safeApiCall(effect);
}

function* postRequest(url, data, params, options) {
  const effect = call(HttpUtils.post, url, data, params, options);
  return yield safeApiCall(effect);
}

function* putRequest(url, data, params, options) {
  const effect = call(HttpUtils.put, url, data, params, options);
  return yield safeApiCall(effect);
}

function* deleteRequest(url, data, params, options) {
  const effect = call(HttpUtils.delete, url, data, params, options);
  return yield safeApiCall(effect);
}

function* getCrossServerRequest(url) {
  const effect = call(HttpUtils.getCrossServer, url);
  return yield safeApiCall(effect);
}

export {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  getCrossServerRequest,
};
